/**
 * Custom Autocomplete component based on Vuexy design.
 * Provides consistent styling across the application.
 */

// React imports
import { forwardRef } from 'react';
import type { ElementType } from 'react';

// MUI imports
import Paper from '@mui/material/Paper';
import Autocomplete from '@mui/material/Autocomplete';
import type { AutocompleteProps } from '@mui/material/Autocomplete';

/**
 * Custom Autocomplete component with Vuexy styling.
 * @param props - Autocomplete props
 * @param ref - Forwarded ref
 */
const CustomAutocomplete = forwardRef(
  <
    T,
    Multiple extends boolean | undefined,
    DisableClearable extends boolean | undefined,
    FreeSolo extends boolean | undefined,
    ChipComponent extends ElementType,
  >(
    props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo, ChipComponent>,
    ref: any
  ) => {
    return (
      <Autocomplete
        {...props}
        ref={ref}
        slots={{
          paper: (props) => <Paper {...props} />,
        }}
      />
    );
  }
) as typeof Autocomplete;

// `displayName` exists at runtime, but the generic function type doesn't expose it.
// Cast to `unknown` to keep strict typing without `any`.
(CustomAutocomplete as unknown as { displayName?: string }).displayName = 'CustomAutocomplete';

export default CustomAutocomplete;
